import {
  getSamePeriodLastYearWithMatchdayoftheWeek,
  getPrecedingPeriodMatchDayOftheWeek,
  getPrecedingPeriod,
  getSamePeriodLastYear,
  getNullCase,
} from "helpers"
import { commonComponentIcons, icons } from "helpers/images"
import moment from "moment"
import React, { forwardRef, useState, useEffect, useRef } from "react"
import ReactDatePicker from "react-datepicker"
import "./styles.scss"
import { useDispatch, useSelector } from "react-redux"
import { activeCustomeDateFilter } from "redux/action/ReportPage"
import { date } from "yup"
const CustomDatePickers = ({
  onChange,
  dates,
  setDates,
  selected,
  placeholder,
  pickerType = "date",
  isCustomeDatePickerSidebar = true,
  isCustomeDatePickerHeader = true,
  selectMonthToDate = true,
  selectYeartoDate = true,
  maxOneYear = false,
}) => {

  const [activeNormal, setActiveNormal] = useState("")
  const [isOpen, setIsOpen] = useState(false)
  const [activeComparison, setActiveComparison] = useState("")
  const [monthBydate, setMonthBydate] = useState(new Date())
  const dispatch = useDispatch()
  const getActiveData = useSelector((state) => state?.ReportPage?.customeDateFilterActive)

  // Custom Input Component


  const CustomInput = forwardRef(({ value, onClick, placeholder }, ref) => (
    <div
      className="report-datePicker"
      onClick={() => {
        setIsOpen(true)
        onClick()
      }}
      ref={ref}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          border: "1px solid #ced4da",
          borderRadius: "4px",
          padding: "6px",
          cursor: "pointer",
          maxWidth: "300px",
          width: "275px",
        }}
      >
        <img
          alt="calendar"
          src={icons.calender}
          style={{ marginRight: "4px" }}
        />
        <input
          type="text"
          placeholder={pickerType === "month" ? " Month Range" : "Date Range"}
          value={value}
          readOnly
          style={{
            border: "none",
            outline: "none",
            backgroundColor: "transparent",
            width: "220px",
            // width: value ? `${value.length}ch` : "250px",
          }}
        />
        <img
          alt="dropDown"
          src={commonComponentIcons.CustomDropdown}
          style={{ width: "10px", height: "10px" }}
        />
      </div>
    </div>
  ))

  // Custom Header Component
  const CustomHeader = ({
    date,

    customHeaderCount,
    changeYear,

    changeMonth,
    decreaseMonth,
    increaseMonth,
    prevMonthButtonDisabled,
    nextMonthButtonDisabled,
  }) => {
    const getYears = (startYear = 1900, endYear = new Date().getFullYear()) => {
      let start = startYear
      let years = [start]

      while (start !== endYear) {
        start += 1
        years.push(start)
      }

      return years
    }

    const months = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ]

    const years = getYears(
      new Date().getFullYear() - 34,
      new Date().getFullYear() + 10
    )

    useEffect(() => {
      setMonthBydate(date)
    }, [date])

    const handleNextPreviousMonths = (type, e) => {
      e.preventDefault()

      setMonthBydate(date)
      if (type === "next") {
        increaseMonth(e)
      } else {
        decreaseMonth(e)
      }
    }

    return (
      <div>
        {dates?.isInputHeader &&
          customHeaderCount == 0 &&
          isCustomeDatePickerHeader && (
            // <div className="d-flex flex-column mb-2">
            <div className="dates-container">
              <div className="dates-section d-flex flex-column p-2">
                <div className="d-flex justify-content-between">
                  <div>
                    <label className="date-label">Start Date</label>
                    <div className="date-value">
                      {" "}
                      {dates?.startDate
                        ? moment(dates?.startDate).format("DD-MM-YYYY")
                        : ""}
                    </div>
                  </div>
                  <div>
                    <label></label>
                    <div>_</div>
                  </div>
                  <div>
                    <label className="date-label">End Date</label>
                    <div>
                      {" "}
                      {dates?.endDate
                        ? moment(dates?.endDate).format("DD-MM-YYYY")
                        : ""}
                    </div>
                    {/* <div className="date-value"> 02-Nov-2023</div> */}
                  </div>
                </div>
              </div>
              {dates?.compare && (
                <>
                  <div className="compare-to">Compare to</div>
                  <div className="dates-container d-flex flex-column p-2">
                    <div className="d-flex justify-content-between">
                      <div>
                        <label className="date-label">Start Date</label>
                        <div className="date-value">
                          {" "}
                          {dates?.comparisonStartDate
                            ? moment(dates?.comparisonStartDate).format(
                                "DD-MM-YYYY"
                              )
                            : ""}
                        </div>
                        {/* <div className="date-value"> 04-Oct-2023</div> */}
                      </div>
                      <div>
                        <label></label>
                        <div>_</div>
                      </div>
                      <div>
                        <label className="date-label">End Date</label>
                        <div className="date-value">
                          {" "}
                          {dates?.comparisonEndDate
                            ? moment(dates?.comparisonEndDate).format(
                                "DD-MM-YYYY"
                              )
                            : ""}
                        </div>
                        {/* <div className="date-value"> 02-Nov-2023</div> */}
                      </div>
                    </div>
                  </div>
                </>
              )}
            </div>
          )}

        {customHeaderCount == 0 && (
          <div className="d-flex align-items-center justify-content-between">
            {/* Month Selector */}
            <div>
              <select
                value={months[new Date(date)?.getMonth()]}
                onChange={({ target: { value } }) =>
                  changeMonth(months.indexOf(value))
                }
                className="month-selector"
              >
                {months.map((option) => (
                  <option key={option} value={option}>
                    {option}
                  </option>
                ))}
              </select>

              {/* Year Selector */}
              <select
                value={years.find(
                  (year) => year == new Date(date).getFullYear()
                )}
                onChange={({ target: { value } }) => changeYear(value)}
                className="year-selector"
              >
                {years.map((option) => (
                  <option key={option} value={option}>
                    {option}
                  </option>
                ))}
              </select>
            </div>

            {/* Previous Month Button */}
            <div>
              <img
                alt="leftArrowWithoutTail"
                src={icons.leftArrowWithoutTail}
                className="bg-white border-0 prev-button"
                onClick={(e) => handleNextPreviousMonths("prev", e)}
                disabled={prevMonthButtonDisabled}
              />

              {/* Next Month Button */}
              <img
                alt="rightArrowWithoutTail"
                src={icons.rightArrowWithoutTail}
                onClick={(e) => handleNextPreviousMonths("next", e)}
                disabled={nextMonthButtonDisabled}
                className="bg-white border-0 next-button"
              />
            </div>
          </div>
        )}

        {/* {customHeaderCount == 0 ? (
          <div
            style={{
              margin: 10,
              justifyContent: "center",
            }}
            // className="report-datepicker"
          >
            <div className="my-2">
              {" "}
              <h5 className="fw-600 fs-16">
                {" "}
                {months[new Date(monthBydate)?.getMonth() - 1]}
              </h5>
            </div>
          </div>
        ) : (
          <div className="my-2">
            <h5 className="fw-600">
              {months[new Date(monthBydate)?.getMonth()]}{" "}
            </h5>
          </div>
        )} */}
      </div>
    )
  }
  const isSelectingEndMonth =
  maxOneYear &&
  dates?.startDate &&
  !dates?.endDate;

const maxSelectableMonth = isSelectingEndMonth
  ? moment(dates.startDate)
      .add(11, "months")
      .endOf("month")
      .toDate()
  : new Date();
  const CustomContainers = () => {
    const toggleComparisonFields = () => {
      setDates((prev) => ({
        ...prev,
        compare: !dates.compare,
      }))
      handleComparisonDate("nullCase")
      setActiveComparison("")
    }

    const getRangeDate = async (event) => {
      let newDates = { ...dates, activePage: 1 }
      setActiveNormal(event)
      dispatch(activeCustomeDateFilter({ CustomeDate: event }))
      let currentMonth = moment().format("M")

      switch (event) {
        case "today":
          newDates.startDate = moment().toDate()
          newDates.endDate = moment().toDate()
          break

        case "YESTERDAY":
          newDates.startDate = moment().subtract(1, "days").toDate()
          newDates.endDate = moment().subtract(1, "days").toDate()
          break

        case "LAST_7":
          newDates.startDate = moment().subtract(6, "days").toDate()
          newDates.endDate = moment().toDate()
          break

        case "LAST_28":
          newDates.startDate = moment().subtract(27, "days").toDate()
          newDates.endDate = moment().toDate()
          break

        case "LAST_30":
          newDates.startDate = moment().subtract(29, "days").toDate()
          newDates.endDate = moment().toDate()
          break

        case "LAST_90":
          newDates.startDate = moment().subtract(89, "days").toDate()
          newDates.endDate = moment().toDate()
          break

        case "LAST_12":
          newDates.startDate = moment().subtract(1, "year").toDate()
          newDates.endDate = moment().toDate()
          break

        case "THIS_WEEK":
          newDates.startDate = moment().startOf("week").toDate()
          newDates.endDate = moment().toDate()
          break

        case "THIS_MONTH":
          newDates.startDate = moment().startOf("month").toDate()
          newDates.endDate = moment().toDate()
          break

        case "THIS_YEAR":
          if (currentMonth < 4) {
            newDates.startDate = moment()
              .subtract(1, "year")
              .startOf("year")
              .add(3, "months")
              .toDate()
          } else {
            newDates.startDate = moment()
              .startOf("year")
              .add(3, "months")
              .toDate()
          }
          newDates.endDate = moment().toDate()
          break

        case "LAST_YEAR":
          if (currentMonth < 4) {
            newDates.startDate = moment()
              .subtract(2, "years")
              .startOf("year")
              .add(3, "months")
              .toDate()
            newDates.endDate = moment()
              .subtract(1, "year")
              .startOf("year")
              .add(2, "months")
              .endOf("month")
              .toDate()
          } else {
            newDates.startDate = moment()
              .subtract(1, "year")
              .startOf("year")
              .add(3, "months")
              .toDate()
            newDates.endDate = moment()
              .startOf("year")
              .add(2, "months")
              .endOf("month")
              .toDate()
          }
          break;

        case "LAST_WEEK":
          newDates.startDate = moment()
            .subtract(1, "week")
            .startOf("week")
            .toDate()
          newDates.endDate = moment().subtract(1, "week").endOf("week").toDate()
          break

        default:
          newDates.startDate = moment().toDate()
          newDates.endDate = moment().toDate()
      }

      setDates((prevDates) => {
        const updatedDates = { ...prevDates, ...newDates };

        // Only call handleComparisonDate when state is updated
        setTimeout(() => {
          handleComparisonDate(getActiveData?.ComparedDate, updatedDates);
        }, 0);

        return updatedDates;
      });
      // handleComparisonDate(getActiveData?.ComparedDate)
    }



    useEffect(() => {
      if (dates?.isPackegeDateClicked && dates?.endDate) {
        dispatch(activeCustomeDateFilter({ CustomeDate: null }));
        setTimeout(() => {
          handleComparisonDate(getActiveData?.ComparedDate, dates);
        }, 0);
        setDates((prev) => ({
          ...prev, isPackegeDateClicked: !dates?.isPackegeDateClicked
        }))
      }
    }, [dates?.isPackegeDateClicked]); // Only track this field




    const handleComparisonDate = async (type, updatedDates) => {


      const date = updatedDates
      console.log(date, "123456")
      setActiveComparison(type)
      dispatch(activeCustomeDateFilter({ ComparedDate: type }));

      let comparisonDates

      switch (type) {
        case "precedingPeriodMatchDayofTheWeek":
          comparisonDates = getPrecedingPeriodMatchDayOftheWeek(
            updatedDates?.startDate,
            updatedDates?.endDate
          )
          break
        case "samePeriodLastYearMatchDayofTheWeek":
          comparisonDates = getSamePeriodLastYearWithMatchdayoftheWeek(
            updatedDates?.startDate,
            updatedDates?.endDate
          )
          break
        case "precedingPeriod":
          comparisonDates = getPrecedingPeriod(updatedDates?.startDate, updatedDates?.endDate)
          break
        case "samePeriodLastYear":
          comparisonDates = getSamePeriodLastYear(
            updatedDates?.startDate,
            updatedDates?.endDate
          )
          break
        case "nullCase":
          comparisonDates = getNullCase(
            updatedDates?.startDate,
            updatedDates?.endDate
          )
          break
        default:
          return
      }

      setDates((prevDates) => ({
        ...prevDates,
        comparisonStartDate: comparisonDates?.startDate,
        comparisonEndDate: comparisonDates?.endDate,
      }))
    }

    return (
      <div
        style={{
          maxHeight: "490px",
          overflow: "scroll",
          background: "white",
          borderRadius: "5px",
          width: "200px",
        }}
      >
        <div style={{ backgroundColor: "#f9f9fa" }} className="p-4">
          <h5 className="mb-3 fs-14 fw-700 custom-txt ">Custom</h5>

          <p
            className={`cursor-pointer ${
              getActiveData?.CustomeDate === "today" ? "activedate" : ""
            }`}
            onClick={() => getRangeDate("today")}
          >
            Today
          </p>
          <p
            className={`cursor-pointer ${
              getActiveData?.CustomeDate === "YESTERDAY" ? "activedate" : ""
            }`}
            onClick={() => getRangeDate("YESTERDAY")}
          >
            Yesterday
          </p>
          <p
            className={`cursor-pointer ${
              getActiveData?.CustomeDate === "THIS_WEEK" ? "activedate" : ""
            }`}
            onClick={() => getRangeDate("THIS_WEEK")}
          >
            This week
          </p>
          <p
            className={`cursor-pointer ${
              getActiveData?.CustomeDate === "LAST_WEEK" ? "activedate" : ""
            }`}
            onClick={() => getRangeDate("LAST_WEEK")}
          >
            Last week
          </p>
          <p
            className={`cursor-pointer ${
              getActiveData?.CustomeDate === "LAST_7" ? "activedate" : ""
            }`}
            onClick={() => getRangeDate("LAST_7")}
          >
            Last 7 days
          </p>
          <p
            className={`cursor-pointer ${
              getActiveData?.CustomeDate === "LAST_28" ? "activedate" : ""
            }`}
            onClick={() => getRangeDate("LAST_28")}
          >
            Last 28 days
          </p>
          <p
            className={`cursor-pointer ${
              getActiveData?.CustomeDate === "LAST_30" ? "activedate" : ""
            }`}
            onClick={() => getRangeDate("LAST_30")}
          >
            Last 30 days
          </p>
          <p
            className={`cursor-pointer ${
              getActiveData?.CustomeDate === "THIS_MONTH" ? "activedate" : ""
            }`}
            onClick={() => getRangeDate("THIS_MONTH")}
          >
            This month
          </p>
          <p
            className={`cursor-pointer ${
              getActiveData?.CustomeDate === "LAST_90" ? "activedate" : ""
            }`}
            onClick={() => getRangeDate("LAST_90")}
          >
            Last 90 days
          </p>
          <p
            className={`cursor-pointer ${
              getActiveData?.CustomeDate === "LAST_12" ? "activedate" : ""
            }`}
            onClick={() => getRangeDate("LAST_12")}
          >
            Last 12 Months
          </p>
          <p
            className={`cursor-pointer ${
              getActiveData?.CustomeDate === "THIS_YEAR" ? "activedate" : ""
            }`}
            onClick={() => getRangeDate("THIS_YEAR")}
          >
            This Year (Apr - Today)
          </p>
          <p
            className={`cursor-pointer ${
              getActiveData?.CustomeDate === "LAST_YEAR" ? "activedate" : ""
            }`}
            onClick={() => getRangeDate("LAST_YEAR")}
          >
            Last Year (Apr - Mar)
          </p>
          {dates?.isToggleButton && dates?.startDate && (
            <div class="form-check form-switch">
              <input
                class="form-check-input"
                type="checkbox"
                role="switch"
                id="flexSwitchCheckChecked"
                onClick={toggleComparisonFields}
                checked={dates?.compare}
              />
            </div>
          )}

          {dates?.compare && (
            <div>
              <p
                className={`cursor-pointer ${
                  getActiveData?.ComparedDate === "precedingPeriodMatchDayofTheWeek"
                    ? "activedate"
                    : ""
                }`}
                onClick={() =>
                  handleComparisonDate("precedingPeriodMatchDayofTheWeek", dates)
                }
              >
                Preceding Period (match day of week)
              </p>
              <p
                className={`cursor-pointer ${
                  getActiveData?.ComparedDate === "samePeriodLastYearMatchDayofTheWeek"
                    ? "activedate"
                    : ""
                }`}
                onClick={() =>
                  handleComparisonDate("samePeriodLastYearMatchDayofTheWeek", dates)
                }
              >
                Same Period Last Year (match day of week)
              </p>
              <p
                className={`cursor-pointer ${
                  getActiveData?.ComparedDate === "precedingPeriod" ? "activedate" : ""
                }`}
                onClick={() => handleComparisonDate("precedingPeriod", dates)}
              >
                Preceding Period
              </p>
              <p
                className={`cursor-pointer ${
                  getActiveData?.ComparedDate === "samePeriodLastYear" ? "activedate" : ""
                }`}
                onClick={() => handleComparisonDate("samePeriodLastYear", dates)}
              >
                Same Period Last Year
              </p>
              {/* Apply and Cancel buttons */}
              <div className="comparison-controls">
                {/* <button onClick={applyComparisonDates}>Apply</button>
              <button onClick={cancelComparison}>Cancel</button> */}
              </div>
            </div>
          )}
        </div>
      </div>
    )
  }
  const handleToCancelDates = () => {
    setDates((prev) => ({
      ...prev,
      startDate: null,
      endDate: null
    }));
    setIsOpen(false);
  };

  // Custom Wrapper Component
  const CustomWrapper = ({ className, children, ...rest }) => (
    <div className="d-flex flex-column full_date_picker_box">
      <div className="d-flex flex-row-reverse">
        <div
          style={{
            width: "245px",
            borderRadius: "5px",
            maxHeight: "500px",
            overflow: "scroll",
          }}
          className="report-custom-datepicker"
        >
          {children}
        </div>
        {isCustomeDatePickerSidebar ? (
          <div>
            <CustomContainers />
          </div>
        ) : null}
      </div>
      <div className="datepicker_footer_buttons">
        <button onClick={() => handleToCancelDates()} className="cancel-button">
          Cancel
        </button>
        <button onClick={() => setIsOpen(false)} className="apply-button">
          Apply
        </button>
      </div>
    </div>
  )

  return (
    <div className="">
      <ReactDatePicker
        monthsShown={pickerType === "month" ? 1 : 1} // 1 month for month view, 6 for date range
        selectsStart={pickerType === "month" || isCustomeDatePickerSidebar} // For month or range selection start
        selectsRange={
          selectMonthToDate &&
          (pickerType === "month" || isCustomeDatePickerSidebar)
        } // Enables range selection for month or date range
        swapRange={isCustomeDatePickerSidebar} // Swap range if necessary (only for date range)
        renderCustomHeader={(props) => <CustomHeader {...props} />}
        calendarContainer={CustomWrapper}
        startDate={
          pickerType === "month" || isCustomeDatePickerSidebar
            ? dates?.startDate
            : null
        } // Start date for month or range
        endDate={
          pickerType === "month" || isCustomeDatePickerSidebar
            ? dates?.endDate
            : null
        } // End date for month or range
        selected={
          selectYeartoDate === false
            ? dates?.year
            : selectMonthToDate === false
            ? dates?.month
            : !isCustomeDatePickerSidebar && pickerType !== "month"
            ? dates?.startDate
            : null
        } // Single date for normal date selection
        maxDate={maxSelectableMonth} // Maximum date is today
        onChange={onChange} // Handle onChange event for single or range
        dateFormat={
          selectYeartoDate === false
            ? "yyyy"
            : pickerType === "month"
            ? "MMMM yyyy"
            : "MMM d, yyyy"
        } // Date format based on type
        placeholderText={placeholder || "Date Range"}
        open={isOpen} // Control whether the picker is open
        showPreviousMonths={true} // Show previous months for better range visibility
        onCalendarOpen={() => setIsOpen(true)} // Handle calendar open event
        onCalendarClose={() => setIsOpen(false)} // Handle calendar close event
        shouldCloseOnSelect={
          pickerType !== "month" && !isCustomeDatePickerSidebar
        } // Close on select for single date picker
        showMonthYearPicker={pickerType === "month"} // Show only months for month-based picker
        showYearPicker={pickerType === "year"}
        customInput={<CustomInput />} // Custom input component
      />
    </div>
  )
}

export default CustomDatePickers;
